import Input from "./FieldInput";
import { withErrorMessage } from "../withErrorMessage";

export const FieldInput = withErrorMessage(Input);

export default Input;
